export default "__VITE_ASSET__kPrHdgxU__"